"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectWorkspaceSheet = SelectWorkspaceSheet;
var _react = _interopRequireWildcard(require("react"));
var _badge = require("@design/ui/badge");
var _field = require("@design/ui/field");
var _radioGroup = require("@design/ui/radio-group");
var _searchInput = require("@design/ui/search-input");
var _foldedTextSearch = require("@common/utils/foldedTextSearch");
var _importedBottomSheet = require("@common/components/chat-composer/sheets/imported-bottom-sheet");
var _confirmationDialog = require("@common/components/confirmation-dialog/confirmation-dialog");
var _AuthContext = require("../../../context/AuthContext");
var _api = require("../../../utils/api");
var _toast = require("../../../utils/toast");
var _workspaceTagFilter = require("../workspace-tag-filter");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function workspaceListNotice(listState, workspaceCount, visibleWorkspaceCount) {
  if (listState === "loading") return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: "px-3 py-2 text-sm text-muted-foreground",
    children: "Loading workspaces\u2026"
  });
  if (listState === "failed") return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: "px-3 py-2 text-sm text-destructive",
    children: "Unable to load workspaces."
  });
  if (workspaceCount === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "px-3 py-2 text-sm text-muted-foreground",
      children: "No workspaces found. Create one in the Dioptra web app first."
    });
  }
  if (visibleWorkspaceCount === 0) return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: "px-3 py-2 text-sm text-muted-foreground",
    children: "No workspaces match your search."
  });
  return null;
}
function SelectWorkspaceSheet(_ref) {
  var _project$id, _workspaces$find;
  var onClose = _ref.onClose,
    project = _ref.project,
    attach = _ref.attach,
    chatName = _ref.chatName;
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    workspaces = _useState2[0],
    setWorkspaces = _useState2[1];
  var _useState3 = (0, _react.useState)("loading"),
    _useState4 = _slicedToArray(_useState3, 2),
    listState = _useState4[0],
    setListState = _useState4[1];
  var _useState5 = (0, _react.useState)(""),
    _useState6 = _slicedToArray(_useState5, 2),
    query = _useState6[0],
    setQuery = _useState6[1];
  var _useState7 = (0, _react.useState)((_project$id = project === null || project === void 0 ? void 0 : project.id) !== null && _project$id !== void 0 ? _project$id : null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedWorkspaceId = _useState8[0],
    setSelectedWorkspaceId = _useState8[1];
  var listRef = (0, _react.useRef)(null);
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isConfirming = _useState0[0],
    setIsConfirming = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isAttaching = _useState10[0],
    setIsAttaching = _useState10[1];
  (0, _react.useEffect)(function () {
    if (!authHeader) return;
    var isStale = false;
    (0, _api.listProjects)(authHeader).then(function (loadedWorkspaces) {
      if (isStale) return;
      setWorkspaces(loadedWorkspaces);
      setListState("loaded");
    }).catch(function () {
      if (!isStale) setListState("failed");
    });
    return function () {
      isStale = true;
    };
  }, [authHeader]);
  var visibleWorkspaces = workspaces.filter(function (workspace) {
    return (0, _foldedTextSearch.matchesSearch)(workspace.name, query) || (0, _foldedTextSearch.matchesSearch)(workspace.description, query);
  });
  var selectedWorkspace = (_workspaces$find = workspaces.find(function (workspace) {
    return workspace.id === selectedWorkspaceId;
  })) !== null && _workspaces$find !== void 0 ? _workspaces$find : null;
  var isSelectionNew = selectedWorkspace !== null && selectedWorkspace.id !== (project === null || project === void 0 ? void 0 : project.id);
  function attachSelectedWorkspace() {
    return _attachSelectedWorkspace.apply(this, arguments);
  }
  function _attachSelectedWorkspace() {
    _attachSelectedWorkspace = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (selectedWorkspace) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setIsAttaching(true);
            _context.p = 2;
            _context.n = 3;
            return attach(selectedWorkspace.id);
          case 3:
            onClose();
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            (0, _toast.toastError)(_t instanceof Error ? _t : "Failed to update workspace.");
            setIsAttaching(false);
            setIsConfirming(false);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4]]);
    }));
    return _attachSelectedWorkspace.apply(this, arguments);
  }
  function handleSelectWorkspace() {
    if (chatName !== null) {
      setIsConfirming(true);
      return;
    }
    void attachSelectedWorkspace();
  }
  function renderWorkspaceCard(workspace) {
    var radioId = "select-workspace-".concat(workspace.id);
    var description = workspace.description ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldDescription, {
      children: workspace.description
    }) : null;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.FieldLabel, {
      htmlFor: radioId,
      "data-testid": "select-workspace-card",
      className: "w-full cursor-pointer rounded-lg border border-transparent px-3 py-2 has-[[aria-checked=true]]:border-primary",
      "data-sentry-element": "FieldLabel",
      "data-sentry-component": "renderWorkspaceCard",
      "data-sentry-source-file": "SelectWorkspaceSheet.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.FieldContent, {
        className: "min-w-0",
        "data-sentry-element": "FieldContent",
        "data-sentry-source-file": "SelectWorkspaceSheet.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex w-full items-start gap-2",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldTitle, {
            className: "min-w-0 font-normal",
            "data-sentry-element": "FieldTitle",
            "data-sentry-source-file": "SelectWorkspaceSheet.tsx",
            children: workspace.name
          }), workspace.tags.map(function (tag) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_badge.Badge, {
              className: "ml-auto shrink-0",
              children: (0, _workspaceTagFilter.tagLabel)(tag.name)
            }, tag.id);
          })]
        }), description]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_radioGroup.RadioGroupItem, {
        id: radioId,
        value: workspace.id,
        className: "sr-only",
        "data-sentry-element": "RadioGroupItem",
        "data-sentry-source-file": "SelectWorkspaceSheet.tsx"
      })]
    }, workspace.id);
  }
  var confirmation = isConfirming && selectedWorkspace && chatName !== null ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
    tone: "primary",
    title: "Connect chat with workspace",
    message: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: ["This moves ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: chatName
      }), " to ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: selectedWorkspace.name
      }), ". You can change the chat's workspace again at any time."]
    }),
    confirmLabel: "Connect",
    confirmDisabled: isAttaching,
    cancelDisabled: isAttaching,
    onCancel: function onCancel() {
      return setIsConfirming(false);
    },
    onConfirm: attachSelectedWorkspace
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_importedBottomSheet.BottomSheet, {
      onClose: onClose,
      title: "Select Workspace",
      description: "Choose a workspace for this chat",
      confirm: {
        label: "Select Workspace",
        onConfirm: handleSelectWorkspace,
        isDisabled: !isSelectionNew || isAttaching
      },
      scrollAreaRef: listRef,
      "data-sentry-element": "BottomSheet",
      "data-sentry-source-file": "SelectWorkspaceSheet.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_searchInput.SearchInput, {
        "data-autofocus": true,
        className: "shrink-0",
        placeholder: "Search workspaces\u2026",
        "aria-label": "Search workspaces",
        value: query,
        onValueChange: setQuery,
        "data-sentry-element": "SearchInput",
        "data-sentry-source-file": "SelectWorkspaceSheet.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_radioGroup.RadioGroup, {
        ref: listRef,
        "aria-label": "Workspaces",
        value: selectedWorkspaceId !== null && selectedWorkspaceId !== void 0 ? selectedWorkspaceId : "",
        onValueChange: setSelectedWorkspaceId,
        className: _importedBottomSheet.IMPORTED_SHEET_LIST_CLASS,
        "data-sentry-element": "RadioGroup",
        "data-sentry-source-file": "SelectWorkspaceSheet.tsx",
        children: [visibleWorkspaces.map(renderWorkspaceCard), workspaceListNotice(listState, workspaces.length, visibleWorkspaces.length)]
      })]
    }), confirmation]
  });
}